import React, { useState, useEffect, useMemo } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Hire from "../Hire-me";
import ProjectCard from "../ui/ProjectCards";
import CategoryFilter from "../ui/CategoryFilter";
import event1 from "../../assets/imgs/event1.png";
import event12 from "../../assets/imgs/event12.png";
import event13 from "../../assets/imgs/event13.png";
import event7 from "../../assets/imgs/event7.png";
import pro1 from '../../assets/imgs/delight-home.png';
import pro2 from '../../assets/imgs/pro-2.png';
import pro3 from '../../assets/imgs/pro-3.png';
import pro4 from '../../assets/imgs/test-pro1.png';
import pro5 from '../../assets/imgs/pro-5.png';
import pro6 from '../../assets/imgs/Game1.png';
import pro7 from '../../assets/imgs/We8-1.png';
import pro8 from "../../assets/imgs/portfolio1.png";

const projectsData = [
  {
    id: 1,
    title: "EventGlow - Smart Event Planner & Budget Optimizer",
    description: "Full-stack event management platform with vendor booking, expense tracking, secure authentication, and responsive dashboards.",
    image: event1,
    liveUrl: "https://event-glow.netlify.app/",
    sourceUrl: "private",
    category: "Full Stack",
    technologies: ['React','TypeScript','Express','Node.js','MySQL','Tailwind'],
    featured: true,
  },
  {
    id: 2,
    title: "My Portfolio",
    description: "Modern developer portfolio showcasing full-stack projects, services, skills, and responsive web design.",
    image: pro8,
    liveUrl: "https://stj-portfolio.netlify.app",
    sourceUrl: "private",
    category: "Full Stack",
    technologies: ['React',"Resend",'AOS','Bootstrap'],
    featured: true,
  },
  {
    id: 3,
    title: "Twist Tile Game",
    description: "Interactive React puzzle game featuring 6 challenging levels, tile rotation, and countdown-based gameplay.",
    image: pro6,
    liveUrl: "https://tehzeeb2487.github.io/Twist-Tile-Game/",
    sourceUrl: "https://github.com/tehzeeb2487/Twist-Tile-Game",
    category: "Game",
    technologies: ['React', 'Bootstrap'],
    featured: true,
  },
  {
    id: 4,
    title: "EventGlow – Admin Dashboard",
    description: "Role-based admin panel for managing users, vendors, services, bookings, and platform analytics.",
    demoCredentials: {
      email: "admin01@gmail.com",
      password: "24680admin"
    },
    image: event12,
    liveUrl: "https://event-glow.netlify.app/#/login",
    sourceUrl: "private",
    category: "Dashboard",
    technologies: ['React','TypeScript','Express','Node.js','MySQL','Tailwind'],
    featured: false,
  },
  {
    id: 5,
    title: "EventGlow – Vendor Dashboard",
    description: "Vendor dashboard to manage services, bookings, availability, and customer requests.",
    demoCredentials: {
      email: "vendor01@gmail.com",
      password: "vendor24680"
    },
    image: event13,
    liveUrl: "https://event-glow.netlify.app/#/login",
    sourceUrl: "private",
    category: "Dashboard",
    technologies: ['React','TypeScript','Express','Node.js','MySQL','Tailwind'],
    featured: false,
  },
  {
    id: 6,
    title: "EventGlow – User Dashboard",
    description: "Plan events, manage bookings, track budgets, and budget optimizer.",
    demoCredentials:{
        email:"priya@gmail.com",
        password:"Priya12345"
    },
    image: event7,
    liveUrl: "https://event-glow.netlify.app/#/login",
    sourceUrl: "private",
    category: "Dashboard",
    technologies: ['React','TypeScript','Express','Node.js','MySQL','Tailwind'],
    featured: false,
  },
  {
    id: 7,
    title: "Bakery Website",
    description: "Responsive React bakery website with smooth navigation, modern UI, and Bootstrap styling.",
    image: pro1,
    liveUrl: "https://tehzeeb2487.github.io/Delight-Bakery/",
    sourceUrl: "https://github.com/tehzeeb2487/Delight-Bakery",
    category: "Website",
    technologies: ['React', 'Bootstrap'],
    featured: false,
  },
  {
    id: 8,
    title: "E-commerce Store",
    description: "Responsive React grocery store interface with product browsing and a clean shopping experience.",
    image: pro7,
    liveUrl: "https://tehzeeb2487.github.io/We8-Grocery/",
    sourceUrl: "https://github.com/tehzeeb2487/We8-Grocery",
    category: "Website",
    technologies: ['React','Bootstrap'],
    featured: false,
  },
  {
    id: 9,
    title: "ShopMaster – E-commerce Dashboard UI",
    description: "Responsive admin dashboard UI for order management, customer details, and product tracking.",
    image: pro2,
    liveUrl: "https://tehzeeb2487.github.io/E-commers-order-page/",
    sourceUrl: "https://github.com/tehzeeb2487/E-commers-order-page",
    category: "Dashboard",
    technologies: ['HTML','CSS','Bootstrap'],
    featured: false,
  },
  {
    id: 10,
    title: "E-commerce Dashboard UI (HTML & CSS)",
    description: "Modern dashboard interface built using HTML and CSS with a responsive layout.",
    image: pro3,
    liveUrl: "https://tehzeeb2487.github.io/E-commerce-Dashboard-UI/",
    sourceUrl: "https://github.com/tehzeeb2487/E-commerce-Dashboard-UI",
    category: "Dashboard",
    technologies: ['HTML','CSS'],
    featured: false,
  },
  {
    id: 11,
    title: "Bootstrap 5 UI Demo",
    description: "Responsive website UI built using only Bootstrap 5 components and grid system.",
    image: pro4,
    liveUrl: "https://tehzeeb2487.github.io/Bootstrap-5-Testing-project/",
    sourceUrl: "https://github.com/tehzeeb2487/Bootstrap-5-Testing-project",
    category: "Website",
    technologies: ['HTML','Bootstrap 5'],
    featured: false,
  },
  {
    id: 12,
    title: "Simple JS Calculator",
    description: "Simple calculator built with HTML, CSS, and JavaScript for basic arithmetic operations.",
    image: pro5,
    liveUrl: "https://tehzeeb2487.github.io/Calculator-repo/",
    sourceUrl: "https://github.com/tehzeeb2487/Calculator-repo",
    category: "Game",
    technologies: ['HTML','CSS','JavaScript'],
    featured: false,
  },
];

const AllProjects = () => {
  const [activeCategory, setActiveCategory] = useState('All');
  const [isAnimating, setIsAnimating] = useState(false);

  const categories = useMemo(() => {
    const uniqueCategories = [...new Set(projectsData.map((p) => p.category))];
    return ['All', ...uniqueCategories];
  }, []);

  const filteredProjects = useMemo(() => {
    if (activeCategory === 'All') return projectsData;
    return projectsData.filter((p) => p.category === activeCategory);
  }, [activeCategory]);

  const handleCategoryChange = (category) => {
    setIsAnimating(true);
    setActiveCategory(category);
    setTimeout(() => setIsAnimating(false), 300);
  };

  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true,
    })
  }, [])

  return (
    <>
    <section className="align-items-start flex-column header h-auto" id="allProjects">
      <div className="overlay"></div>
      <div className="service-head d-flex flex-column justify-content-center align-items-center" data-aos="fade-up">
        <div className="header-content d-flex flex-column justify-content-center align-items-center mx-auto p-0">
          <h1 className="projects-title">My Projects</h1>
          <p className="header-subtitle text-center">What I Did?</p>
          <p className="header-description text-center">
            Explore my portfolio of web development projects, from full-stack applications to responsive landing pages.
          </p>
        </div>

        <CategoryFilter
          categories={categories}
          activeCategory={activeCategory}
          onCategoryChange={handleCategoryChange}
        />

        <div className={`projects-grid ${isAnimating ? 'animating' : ''}`}>
          <div className="row m-0 mx-5">
            {filteredProjects.map((project, index) => (
              <ProjectCard
                key={project.id}
                image={project.image}
                title={project.title}
                description={project.description}
                demoCredentials={project.demoCredentials}
                category={project.category}
                technologies={project.technologies}
                liveUrl={project.liveUrl}
                sourceUrl={project.sourceUrl}
                featured={project.featured}
                delay={index * 50}
              />
            ))}
          </div>
        </div>
      </div>
    </section>

    <Hire />
    </>
  );
};

export default AllProjects;
